/* 
returns a dot based path

e.g.  concatPath('one', ['two', 'three.four'], 'five.six') 
returns : 'one.two.three.four.five.size'
*/
module.exports = function concatPath () {

  let pathArray = []

  Object.values(arguments).map(val => {

    if(typeof val === 'undefined') {
      
    } else if(Array.isArray(val)) {
      val.flat(100).forEach(v => {
        pathArray = [...pathArray, ...v.split('.')]
      })
    } else {
      pathArray = [...pathArray, ...val.split('.')]
    }
  })

  return pathArray.length > 0 ? pathArray.join('.') : undefined
  
}
